if (!customElements.get("bundle-product")) {
  customElements.define(
    "bundle-product",
    class BundleProduct extends HTMLElement {
      constructor() {
        super();
        this.mainProductVaraintId = this.dataset.variantid;
        this.maxNumber = this.dataset.maxproduct;
        this.quantityCounter = 0;
        this.bunldeItems = this.querySelectorAll(".bundle-product-grid-item");
        this.defaultBundleButton = this.querySelector("#bundle-add-to-cart");
        this.singleOptionSelectors = this.querySelectorAll(".bundle-grid-variant-select");
        this.quantityBoxOpeners = this.querySelectorAll(
          ".bundle-product-grid-item .bundle-grid-add-button"
        );
        this.quantityButtons = this.querySelectorAll(".bundle-quantity-selector button");
        this.enabledofferet = this.dataset.enabledofferet;
        this.enabledofferetProducts = this.dataset.offeretproducts;
        this.enabled_preorder_widget = false;
        this.initEventListeners();
      }
      initEventListeners(){
        this.quantityBoxOpeners.forEach((el) => {
          el.addEventListener("click",this.openQuantityBox.bind(this));
        });
        this.quantityButtons.forEach( (el) => {
          el.addEventListener("click",this.quantityChangeHandler.bind(this));
        });
         this.defaultBundleButton.addEventListener("click",this.defaultButtonClickHandle.bind(this));
      }
      openQuantityBox(evt){
        evt.preventDefault();
        const parentElement = evt.target.parentElement;
        const currentParentElement = evt.target.closest('.bundle-product-grid-item');
        currentParentElement.classList.add("active");
        evt.target.classList.add("hide");
        parentElement.querySelector(".bundle-grid-quantity").classList.remove("hide");
        parentElement.querySelector(".bundle-quantity-plus").dispatchEvent(new Event("click"));
      }
      quantityChangeHandler(evt){
        console.log(evt, "here once clicked");
        evt.preventDefault();
        
        const inputElement = evt.target.parentElement.querySelector('.bundle-grid-quantity-input');
         const currentParentElement = evt.target.closest('.bundle-product-grid-item');
        if(evt.target.classList.contains('bundle-quantity-plus')){
          if(this.quantityCounter < this.maxNumber){
            inputElement.stepUp();
            this.quantityCounter++;
            currentParentElement.querySelector(".display-qty").textContent= inputElement.value;
          }
        }else{
          if(this.quantityCounter > 0){
            inputElement.stepDown();
            this.quantityCounter--;
            currentParentElement.querySelector(".display-qty").textContent= inputElement.value;
          }
          if(inputElement.value <= 0){
            currentParentElement.querySelector(".bundle-grid-quantity").classList.add("hide");
            currentParentElement.querySelector(".bundle-grid-add-button").classList.remove("hide");
            currentParentElement.classList.remove("active");
          }
        }
        
        this.updateStateAndValue();
      }
      connectedCallback() {
      
      }

      updateStateAndValue(){
        this.quantityCounter = 0;
        this.enabled_preorder_widget = false;
        this.querySelectorAll(
            ".bundle-product-grid-item.active .bundle-grid-quantity-input"
          )
        .forEach((el) => {
          const currentQty = +el.value;
          this.quantityCounter = this.quantityCounter + currentQty;
          if(el.dataset.preorderwidget === 'true'){
            this.enabled_preorder_widget = true;
          }
          
        });
        console.log(this.quantityCounter,"quantityCounter");
        this.selectedBundleAddons = [];
        this.querySelectorAll(".bundle-product-grid-item.active .bundle-grid-quantity-input").forEach((el) => {
          this.selectedBundleAddons.push({
            id:el.dataset.id,
            title:el.dataset.vtitle,
            qty:el.value
          });
        });
        this.querySelector(".bundle-counter").textContent = `${this.quantityCounter}/${this.maxNumber}`;
        if(this.quantityCounter == this.maxNumber ){
          this.defaultBundleButton.querySelector(".budle-text").classList.add("hide");
          this.defaultBundleButton.querySelector(".add-text").classList.remove("hide");
          this.defaultBundleButton.removeAttribute("disabled");
          this.querySelectorAll(".bundle-product-grid-item").forEach( (el) => {
           if(el.querySelector(".bundle-grid-quantity-input").value > 0){
             el.querySelector(".bundle-quantity-plus").setAttribute("disabled","disabled");
             el.querySelector(".bundle-quantity-minus").removeAttribute("disabled");
           }else{
              el.classList.add("opacity-5");
              el.querySelector(".bundle-quantity-plus").setAttribute("disabled","disabled");
              el.querySelector(".bundle-quantity-minus").setAttribute("disabled","disabled");
              const btnopt = el.querySelector(".bundle-grid-add-button");
              if(!btnopt.classList.contains("disabled")){
                btnopt.setAttribute("disabled","disabled")
              }
           }
           
         });
        }else{
          this.defaultBundleButton.querySelector(".budle-text").classList.remove("hide");
          this.defaultBundleButton.querySelector(".add-text").classList.add("hide");
          this.defaultBundleButton.setAttribute("disabled","disabled");

          this.querySelectorAll(".bundle-product-grid-item").forEach( (el) => {
              el.classList.remove("opacity-5");
              el.querySelector(".bundle-quantity-plus").removeAttribute("disabled");
              el.querySelector(".bundle-quantity-minus").removeAttribute("disabled");
              //el.querySelector(".bundle-grid-add-button:not(.disabled)").removeAttribute("disabled");
              const btnopt = el.querySelector(".bundle-grid-add-button");
              if(!btnopt.classList.contains("disabled")){
                btnopt.removeAttribute("disabled")
              }
          });
        }
        if(this.querySelector(".preorder-widget-wrapper")){
          setTimeout(() => {
            console.log(this.enabled_preorder_widget,"el.dataset.preorderwidget");
           
            if(this.enabled_preorder_widget == true){
              this.querySelector(".preorder-widget-wrapper").classList.remove("hide");
              this.classList.add("preorder-widget-enabled");
               this.defaultBundleButton.querySelector(".add-text").textContent="PRÉCOMMANDER - EXPÉDITION LE 01/08";
            }else{
              this.querySelector(".preorder-widget-wrapper").classList.add("hide");
              this.classList.remove("preorder-widget-enabled");
              this.defaultBundleButton.querySelector(".add-text").textContent="Ajouter au panier";
            }
          },500);
        }
        
         
      }

      
      defaultButtonClickHandle(evt){
        evt.preventDefault();
        this.submitBundleItems();
      }
      submitBundleItems(){
        if(this.selectedBundleAddons.length <= 0 ){
          return false;
        }
        const bundleId = new Date().getTime();      
        let items = [];
        let allproperties = [];
        let bundlerItem = 0;
         let bundleItems = [];
        for(let i in this.selectedBundleAddons){
          if(this.selectedBundleAddons[i]){
            allproperties.push(this.selectedBundleAddons[i].title);
            /*items.push({
              "id":this.selectedBundleAddons[i].id,
              "quantity":this.selectedBundleAddons[i].qty,
              "properties":{
                "_customBundleId":bundleId,
                "_isMainProduct":0,
                "_baseQty":this.selectedBundleAddons[i].qty,
              }
            });*/
            bundleItems.push({
              "_childVariantId":this.selectedBundleAddons[i].id,
              "_baseQty": this.selectedBundleAddons[i].qty,
              "_isMainProduct": 0
            });
            bundlerItem++;
          }
        }
        if( this.enabledofferet === 'true'){
          if(this.enabledofferetProducts){
            const enabledofferetProductsdata = this.enabledofferetProducts.split("___");
            if(enabledofferetProductsdata.length > 0){
              for(let i in enabledofferetProductsdata){
                if(enabledofferetProductsdata[i]){
                  const slitthestring = enabledofferetProductsdata[i].split("||");
                  let productTitle = slitthestring[1];
                  if(slitthestring[2]){
                    if(slitthestring[2].indexOf("Default") > -1){
                    }else{
                      productTitle = `${productTitle}:${slitthestring[2]}`
                    }
                  }
                  allproperties.push(productTitle);
                  bundleItems.push({
                    "_childVariantId":slitthestring[0],
                    "_baseQty":1,
                    "_isMainProduct":0,
                    "_isOffertAddon":1
                  });
                }
              }
            }
          }
        }
        items.push(
          {
            "id":this.mainProductVaraintId,
            "quantity":1,
            "properties":{
              "_customBundleId":bundleId,
              "_isMainProduct":1,
              "Contenu":allproperties.join("|"),
              "childVariants":bundleItems
            }
          }
        );
        let formData = {
         'items':items
        };
        document.dispatchEvent(new CustomEvent("cart:add", {
          detail: {
            data: formData
          }
        }));
       $(".custom-modal__centered.active").removeClass("active"),
       $("body").removeClass("remove-zindex");
      }
    }
  );
}
